// Watchers

function* transactionsSagaWatcher() {}

// eslint-disable-next-line
export default transactionsSagaWatcher;
